import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "../../_helper/auth.guard";

import { StudentUserdataCreateComponent } from "./student-userdata//student-userdata-create/student-userdata-create.component";
import { StudentUserdataListComponent } from "./student-userdata/student-userdata-list/student-userdata-list.component";
import { StudentUsercompareCreateComponent } from "./student-usercompare//student-usercompare-create/student-usercompare-create.component";
import { StudentUsercompareListComponent } from "./student-usercompare/student-usercompare-list/student-usercompare-list.component";
import { StudentUserwishlistCreateComponent } from "./student-userwishlist//student-userwishlist-create/student-userwishlist-create.component";
import { StudentUserwishlistListComponent } from "./student-userwishlist/student-userwishlist-list/student-userwishlist-list.component";


const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "add-student-userdata",
        component: StudentUserdataCreateComponent,
        data: {
          title: "Add Student Userdata",
          breadcrumb: "Add Student Userdata",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-student-userdata/:id",
        component: StudentUserdataCreateComponent,
        data: {
          title: "Edit Student Userdata",
          breadcrumb: "Edit Student Userdata",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "student-userdata-list",
        component: StudentUserdataListComponent,
        data: {
          title: "Student Userdata List",
          breadcrumb: "Student Userdata List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-student-usercompare",
        component: StudentUsercompareCreateComponent,
        data: {
          title: "Add Student Usercompare",
          breadcrumb: "Add Student Usercompare",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-student-usercompare/:id",
        component: StudentUsercompareCreateComponent,
        data: {
          title: "Edit Student Usercompare",
          breadcrumb: "Edit Student Usercompare",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "student-usercompare-list",
        component: StudentUsercompareListComponent,
        data: {
          title: "Student Usercompare List",
          breadcrumb: "Student Usercompare List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-student-userwishlist",
        component: StudentUserwishlistCreateComponent,
        data: {
          title: "Add Student Userwishlist",
          breadcrumb: "Add Student Userwishlist",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-student-userwishlist/:id",
        component: StudentUserwishlistCreateComponent,
        data: {
          title: "Edit Student Userwishlist",
          breadcrumb: "Edit Student Userwishlist",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "student-userwishlist-list",
        component: StudentUserwishlistListComponent,
        data: {
          title: "Student Userwishlist List",
          breadcrumb: "Student Userwishlist List",
        },
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StudentDetailsRoutingModule {}
